import { toast } from '@hivebrite/design-system/Toast';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { handleData } from './handleData';
import { type MakeHandleSubmitParams } from '../types';

export const makeHandleSubmit = ({
  currentUserId,
  isEditingPost,
  isTopicPost,
  onCloseModal,
  onCreate,
  onUpdate,
  topic,
  type,
  userPostId,
  values,
}: MakeHandleSubmitParams) =>
  axios
    .put(
      isTopicPost && topic?.id
        ? Routes.topics_topic_post_path(topic.id, userPostId)
        : Routes.user_post_path(currentUserId, userPostId),
      values,
    )
    .then(
      handleData({
        isEditingPost,
        onCloseModal,
        onCreate,
        onUpdate,
        topic,
        type,
      }),
    )
    .catch(() => {
      toast.error(__('Sorry, an error occurred'));
    });
